'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var fontFamilyBrandonMedium = 'brandon-text-medium';
var fontFamilyBrandonRegular = 'brandon-text-regular';
var fontFamilyChronicleLight = 'chron-icle-light';
var fontFamilyChronicleRoman = 'chron-icle-roman';
var fontsStyle = function (_a) {
    var brandonRegularFile = _a.brandonRegularFile, brandonMediumFile = _a.brandonMediumFile, chronicleLightFile = _a.chronicleLightFile, chronicleRomanFile = _a.chronicleRomanFile;
    return "\n    @font-face {\n        font-family: '" + fontFamilyBrandonMedium + "';\n        font-display: swap;\n        src: url('" + brandonMediumFile + "') format('woff2');\n        font-weight: 550;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: '" + fontFamilyBrandonRegular + "';\n        font-display: swap;\n        src: url('" + brandonRegularFile + "') format('woff2');\n        font-weight: 400;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: '" + fontFamilyChronicleLight + "';\n        font-display: swap;\n        src: url('" + chronicleLightFile + "') format('woff2');\n    }\n    @font-face {\n        font-family: '" + fontFamilyChronicleRoman + "';\n        font-display: swap;\n        src: url('" + chronicleRomanFile + "') format('woff2');\n    }\n";
};
var FontStyle = function (_a) {
    var fontFiles = _a.fontFiles;
    return React__default['default'].createElement("style", null, fontsStyle(fontFiles));
};

var fontFamilies = {
    fontBrandonMedium: "'" + fontFamilyBrandonMedium + "', 'Gill Sans', 'Arial', sans-serif",
    fontBrandonRegular: "'" + fontFamilyBrandonRegular + "', 'Gill Sans', 'Arial', sans-serif",
    fontChronicleLight: "'" + fontFamilyChronicleLight + "', 'Times New Roman', serif",
    fontChronicleRoman: "'" + fontFamilyChronicleRoman + "', 'Times New Roman', serif",
};

exports.FontStyle = FontStyle;
exports.fontFamilies = fontFamilies;
exports.fontsStyle = fontsStyle;
//# sourceMappingURL=index-33f41a46.js.map
